module.exports = __webpack_public_path__ + "0f007c0faa1b609645ebf4015791cee3.MP3";